import Tab from 'bootstrap/js/dist/tab'
import {mdBreakpoint} from "../utils/breakpoints"
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

function initTabs() {

  const tabsBlocks = Array.from(document.querySelectorAll('.js-tabs'))

  tabsBlocks.forEach(tabsBlock => {

    //VARS

    const tabslist = tabsBlock.querySelector('.js-tabslist')
    const tabslistItems = Array.from(tabslist.querySelectorAll('.js-tabslist-item'))
    const tabslistUnderline = tabslist.querySelector('.js-tabslist-underline')

    if (tabslistItems.length > 0) {

      //FUNCTIONS
      const showTabslist = () => {
        tabslist.style.visibility = 'visible'
      }

      //Underline tab on click (desktop)
      const underlineActiveTab = tab => {
        if (mdBreakpoint.matches) {
          const tabslistLeft = tabslist.getBoundingClientRect().left
          const tabLeft = tab.getBoundingClientRect().left
          const tabWidth = tab.offsetWidth
          const activeTabLeft = tabLeft - tabslistLeft

          tabslistUnderline.style.display = 'block'
          tabslistUnderline.style.width = tabWidth + 'px'
          tabslistUnderline.style.transform = 'translateX(' + activeTabLeft + 'px)'
        } else {
          tabslistUnderline.style.display = 'none'
        }
      }

      tabslist.addEventListener('click', function(evt) {
        if ((evt.target.tagName === 'BUTTON')) {
          underlineActiveTab(evt.target)
        }
      })

      //Scroll tabs animation (mobile)
      const scrollAnimateTablist = () => {
        if (!mdBreakpoint.matches && !tabslist.classList.contains('js-no-tabs-animation')) {

          gsap.fromTo(
            tabslist,
            {
              x: 0,
            },
            {
              scrollTrigger: {
                trigger: tabslist,
                start: 'top bottom',
              },
              x: -36,
              yoyo: true,
              repeat: 1,
              duration: 0.4,
              ease: "none"
            })
        } else {
          return false
        }
      }

      //Scroll to tabs list content top (mobile)
      const scrollToTabsContent = () => {

        if (!mdBreakpoint.matches && tabsBlock.classList.contains('-tabs-mobile')) {

          const tabslistContentWrapperTop = tabsBlock.querySelector('.js-tabs-content-wrapper').offsetTop;

          gsap.to(
            window,
            {
              delay: 0,
              duration: .4,
              scrollTo: {
                y: tabslistContentWrapperTop,
                offsetY: 112,
              },
              ease: "none"
            })

        } else {
          return false
        }
      }

      tabslist.addEventListener('click', scrollToTabsContent)


      //Invoke functions after resize
      const invokeAfterResize = () => {
        let rtime
        let timeout = false
        const timeoutDuration = 200

        window.addEventListener('resize', () => {
          rtime = new Date()
          if (timeout === false) {
            timeout = true
            setTimeout(resizeEnd, timeoutDuration)
          }
        })

        const resizeEnd = () => {
          if (new Date() - rtime < timeoutDuration) {
            setTimeout(resizeEnd, timeoutDuration)
          } else {
            timeout = false

            tabslistItems.forEach(tabslistItem => {
              const activeTablistButton = tabslistItem.querySelector('.active')
              if (activeTablistButton) {
                underlineActiveTab(activeTablistButton)
              }
            })
          }
        }
      }

      //Function invocations on page load
      showTabslist()
      underlineActiveTab(tabslistItems[0])
      scrollAnimateTablist()
      invokeAfterResize()

    }
  })
}
initTabs()
